import type { PanelSelectDotProps } from "./types";

export const PanelSelectDot = ({ color }: PanelSelectDotProps) => (
  <span
    aria-hidden
    className="h-3 w-3 flex-none rounded-full border border-slate-300"
    style={{ backgroundColor: color ?? "#cbd5e1" }}
  />
);
